import { useSelector, useDispatch } from "react-redux";
import { useEffect, useRef } from "react";
import { addNotifiedStep, hasNotified, ONBOARDING_STEPS } from "../../../util/constants";
import { notificationSuccess } from "../../../store/actions";

const ONBOARDING_NOTIFICATION_MAP: any = {
  [ONBOARDING_STEPS.GOAL_SETUP]: "You've successfully set your goals. Great start—keep going!",
  [ONBOARDING_STEPS.PRODUCT_TOUR]: "🎉 Great job! You’ve earned $5 for completing the product tour. Keep it up!",
  [ONBOARDING_STEPS.FIRST_DRAFT_CAMPAIGN]: "🎉 Awesome! You’ve earned $5 for creating your first campaign draft. Publish now!",
  [ONBOARDING_STEPS.FIRST_MIN_TOPUP_OF_500]: "🎉 Congratulations! You’ve earned $10 for your first $500 top-up!",
  [ONBOARDING_STEPS.LAUNCH_FIRST_CAMPAIGN]: "🎉 Fantastic! You’ve earned $10 for launching your first campaign!",
};

export default function OnboardingStepWatcher() {
  const dispatch = useDispatch() as any;
  const user = useSelector((state: any) => state.settingReducer.userDetails);

  const prevStep = useRef<string | null>(null);
  const firstRender = useRef<boolean>(true);

  useEffect(() => {
    const current = user?.completed_onboarding_step;
    if (!current) return;

    // Skip first load (no notification when logging in)
    if (firstRender.current) {
      prevStep.current = current;
      firstRender.current = false;
      return;
    }

    // Step changed
    if (prevStep.current !== current) {
      const message = ONBOARDING_NOTIFICATION_MAP[current];

      if (message && !hasNotified(current)) {
        dispatch(notificationSuccess(message));
        addNotifiedStep(current); // Prevent notification again next reload
      }

      prevStep.current = current;
    }
  }, [user?.completed_onboarding_step]);

  return null;
}
